const methy_DMR_KEGG_paths = {
    "CA12DAP_vs_CA15DAP": [
        "/api/static/methy/methy_KEGG/CA12DAP_vs_CA15DAP.CG.DMR_genes.enriched_KEGG_pathway_scatterplot.png",
        "/api/static/methy/methy_KEGG/CA12DAP_vs_CA15DAP.CHG.DMR_genes.enriched_KEGG_pathway_scatterplot.png",
        "/api/static/methy/methy_KEGG/CA12DAP_vs_CA15DAP.CHH.DMR_genes.enriched_KEGG_pathway_scatterplot.png"
    ],
    "CA12DAP_vs_CA9DAP": [
        "/api/static/methy/methy_KEGG/CA12DAP_vs_CA9DAP.CG.DMR_genes.enriched_KEGG_pathway_scatterplot.png",
        "/api/static/methy/methy_KEGG/CA12DAP_vs_CA9DAP.CHG.DMR_genes.enriched_KEGG_pathway_scatterplot.png",
        "/api/static/methy/methy_KEGG/CA12DAP_vs_CA9DAP.CHH.DMR_genes.enriched_KEGG_pathway_scatterplot.png"
    ],
    "CA12DAP_vs_ZY12DAP": [
        "/api/static/methy/methy_KEGG/CA12DAP_vs_ZY12DAP.CG.DMR_genes.enriched_KEGG_pathway_scatterplot.png",
        "/api/static/methy/methy_KEGG/CA12DAP_vs_ZY12DAP.CHG.DMR_genes.enriched_KEGG_pathway_scatterplot.png",
        "/api/static/methy/methy_KEGG/CA12DAP_vs_ZY12DAP.CHH.DMR_genes.enriched_KEGG_pathway_scatterplot.png"
    ],
    "CA15DAP_vs_CA9DAP": [
        "/api/static/methy/methy_KEGG/CA15DAP_vs_CA9DAP.CG.DMR_genes.enriched_KEGG_pathway_scatterplot.png",
        "/api/static/methy/methy_KEGG/CA15DAP_vs_CA9DAP.CHG.DMR_genes.enriched_KEGG_pathway_scatterplot.png",
        "/api/static/methy/methy_KEGG/CA15DAP_vs_CA9DAP.CHH.DMR_genes.enriched_KEGG_pathway_scatterplot.png"
    ],
    "CA15DAP_vs_ZY15DAP": [
        "/api/static/methy/methy_KEGG/CA15DAP_vs_ZY15DAP.CG.DMR_genes.enriched_KEGG_pathway_scatterplot.png",
        "/api/static/methy/methy_KEGG/CA15DAP_vs_ZY15DAP.CHG.DMR_genes.enriched_KEGG_pathway_scatterplot.png",
        "/api/static/methy/methy_KEGG/CA15DAP_vs_ZY15DAP.CHH.DMR_genes.enriched_KEGG_pathway_scatterplot.png"
    ],
    "CA9DAP_vs_ZY9DAP": [
        "/api/static/methy/methy_KEGG/CA9DAP_vs_ZY9DAP.CG.DMR_genes.enriched_KEGG_pathway_scatterplot.png",
        "/api/static/methy/methy_KEGG/CA9DAP_vs_ZY9DAP.CHG.DMR_genes.enriched_KEGG_pathway_scatterplot.png",
        "/api/static/methy/methy_KEGG/CA9DAP_vs_ZY9DAP.CHH.DMR_genes.enriched_KEGG_pathway_scatterplot.png"
    ],
    "ZY12DAP_vs_ZY15DAP": [
        "/api/static/methy/methy_KEGG/ZY12DAP_vs_ZY15DAP.CG.DMR_genes.enriched_KEGG_pathway_scatterplot.png",
        "/api/static/methy/methy_KEGG/ZY12DAP_vs_ZY15DAP.CHG.DMR_genes.enriched_KEGG_pathway_scatterplot.png",
        "/api/static/methy/methy_KEGG/ZY12DAP_vs_ZY15DAP.CHH.DMR_genes.enriched_KEGG_pathway_scatterplot.png"
    ],
    "ZY12DAP_vs_ZY9DAP": [
        "/api/static/methy/methy_KEGG/ZY12DAP_vs_ZY9DAP.CG.DMR_genes.enriched_KEGG_pathway_scatterplot.png",
        "/api/static/methy/methy_KEGG/ZY12DAP_vs_ZY9DAP.CHG.DMR_genes.enriched_KEGG_pathway_scatterplot.png",
        "/api/static/methy/methy_KEGG/ZY12DAP_vs_ZY9DAP.CHH.DMR_genes.enriched_KEGG_pathway_scatterplot.png"
    ],
    "ZY15DAP_vs_ZY9DAP": [
        "/api/static/methy/methy_KEGG/ZY15DAP_vs_ZY9DAP.CG.DMR_genes.enriched_KEGG_pathway_scatterplot.png",
        "/api/static/methy/methy_KEGG/ZY15DAP_vs_ZY9DAP.CHG.DMR_genes.enriched_KEGG_pathway_scatterplot.png",
        "/api/static/methy/methy_KEGG/ZY15DAP_vs_ZY9DAP.CHH.DMR_genes.enriched_KEGG_pathway_scatterplot.png"
    ]
}
export default methy_DMR_KEGG_paths